import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CookieService} from "ngx-cookie-service";
import TokenUtils from "./token-utils";
import {environment} from '../../environments/environment';

@Injectable()
export class AddTokenInterceptor implements HttpInterceptor
{
  constructor(private cookieService: CookieService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>>
  {
    let token = TokenUtils.getToken(this.cookieService, environment.tokenName);
    const cloned = request.clone({
      url: request.url,
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
    return next.handle(cloned);
  }
}
